import { PAGE } from './pages.constants';

/** source (site_id) по партнерам */
export const PARTNER_SOURCES = {
    INTER_RAO: '5281',
    MOSENEGROSBIT: '5950',
    PETROELECTROSBIT: '5951',
    RBK_BANKI: '5266',
    MVIDEO: '7550',
    AVITO: PAGE.AVITO,
} as const;

/** aff_id (tune_id) по партнерам */
export const PARTNER_AFF_IDS = {
    INTER_RAO: '3293',
    ROS_SHTRAFI: '2371',
    MVIDEO: '9250',
    SHTRAFI_PDD: '3713',
    MAIL_RU: '1255',
    LEONID_SVETEKIY: '3282',
    YURIJ_ISAJ: '11887',
    AVITO: '12406',
} as const;

export const AVITO_UTMS = {
    utm_source: 'avito.ru_account_8885',
    utm_medium: 'cpa',
    utm_campaign: 'creditselection_link',
    utm_content: '12406',
};
